import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

type Props = {
  item: Parameters<typeof FormattedMessage>[0];
  a11yItem: Parameters<typeof FormattedMessage>[0];
  noWrapper?: boolean;
};

export const AriaExtendedText: React.FC<Props> = ({
  item,
  a11yItem,
  noWrapper,
}) => {
  if (!item) return null;

  const content = (
    <>
      <Text aria-hidden>
        <FormattedMessage {...item} />
      </Text>
      <AriaText>
        <FormattedMessage {...(a11yItem ?? item)} />
      </AriaText>
    </>
  );

  return noWrapper ? content : <Wrapper>{content}</Wrapper>;
};

const Text = styled.span`
  white-space: nowrap;
`;

const AriaText = styled.span`
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  top: 0;
  left: 0;
`;

const Wrapper = styled.div`
  position: relative;
  width: fit-content;
`;
